import { render, staticRenderFns } from "./QButton.vue?vue&type=template&id=ab15fb2a&"
import script from "./QButton.vue?vue&type=script&lang=js&"
export * from "./QButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports